











import { Component, Prop, Vue } from 'vue-property-decorator';
import { Site } from '@/api';
import InformationRow from '@/components/display/information-row.vue';

@Component({
	components: { InformationRow },
})
export default class SiteRow extends Vue {
	@Prop({ required: true })
	public site!: Site | null;
}
